module.exports = __webpack_public_path__ + "img/regmeetingtop.95bc92b3.png";